<ng-container *transloco="let t; read: 'employee'">
  <ng-container *ngIf="vm$ | async as vm">
    <h2>{{ t("fiscal-year-report") }}</h2>
    <kendo-grid
      [data]="vm.employee.fiscalYearEmployeeReports"
    >
    <kendo-grid-column [title]="t('fiscal-year')">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{(dataItem.fiscalYearId | fiscalYear | async)?.startDate | dateCustom:'month-long' }} - {{(dataItem.fiscalYearId | fiscalYear | async)?.endDate | dateCustom:'month-long' }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="vacationBalance" [title]="t('vacationBalance')"></kendo-grid-column>
    <kendo-grid-column field="flexTimeBalance" [title]="t('flexTimeBalance')">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span >{{ dataItem.flexTimeBalanceObj?.hours }}</span
        ><span> h</span>
        <span> {{ (dataItem.flexTimeBalanceObj?.minutes | number:'2.0')}}</span
        ><span> min</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="overtimeBalance" [title]="t('overtimeBalance')" *ngIf="vm.tenantSettings?.hasOvertime">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span >{{ dataItem.overtimeBalanceObj?.hours }}</span
        ><span> h</span>
        <span> {{ (dataItem.overtimeBalanceObj?.minutes | number:'2.0')}}</span
        ><span> min</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="preWorkTimeBalance" [title]="t('preWorkTimeBalance')">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span >{{ dataItem.preWorkTimeBalanceObj?.hours }}</span
        ><span> h</span>
        <span> {{ (dataItem.preWorkTimeBalanceObj?.minutes | number:'2.0')}}</span
        ><span> min</span>
      </ng-template>
    </kendo-grid-column>
    </kendo-grid>
  </ng-container>
</ng-container>